export const DEFAULT_REQUEST_TIMEOUT = 30000;

export function withTimeout(signalOrTimeMs?: number, signal?: AbortSignal): AbortSignal;
export function withTimeout(signalOrTimeMs?: AbortSignal, timeMs?: number): AbortSignal;
export function withTimeout(signalOrTimeMs?: AbortSignal | number, timeMsOrSignal?: number | AbortSignal): AbortSignal {
    return withTimeoutImpl(...sortArguments(signalOrTimeMs, timeMsOrSignal));
}

function sortArguments(
    signalOrTimeMs: number | AbortSignal | undefined,
    timeMsOrSignal: number | AbortSignal | undefined
) {
    const args = [signalOrTimeMs, timeMsOrSignal];
    const signal = (() => {
        for (const arg of args) if (typeof arg !== 'number') return arg;
    })();
    const time = (() => {
        for (const arg of args) if (typeof arg === 'number') return arg;
        return DEFAULT_REQUEST_TIMEOUT;
    })();
    return [time, signal] as const;
}

function withTimeoutImpl(time: number, outerSignal?: AbortSignal): AbortSignal {
    const ab = new AbortController();
    const ownSignal = ab.signal;

    // no need to clear timeout, additional calls to .abort() do nothing
    setTimeout(() => {
        ab.abort();
    }, time);

    if (!outerSignal) {
        return ownSignal;
    }

    if (outerSignal.aborted) {
        ab.abort(outerSignal.reason);
    } else {
        outerSignal.addEventListener('abort', () => {
            // event can be fired with dispatchEvent and without aborting
            if (outerSignal.aborted) ab.abort(outerSignal.reason);
        });
    }

    return ownSignal;
}
